import { NgClass } from '@angular/common';
import { Component, effect, inject, Input, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { selectServices } from '../../../../../store/global/global.selectors';
import { SubscriptionComponent } from '../../../../shared/helpers/subscription.component';
import { Store } from '@ngrx/store';
import { UsersFiltersStore } from './users-filters.store';
import { OrganizationSettingTypeEnum } from '@libs/types/src/organization/enum/organization-setting-type.enum';
import { SwitchInputComponent } from '../../../../../components/kit/input/switch-input/switch-input.component';
import { SelectInputComponent } from '../../../../../components/kit/input/select-input/select-input.component';
import { SearchInputComponent } from '../../../../../components/kit/input/text-input/search-input.component';

@Component({
    selector: 'app-users-filters',
    templateUrl: './users-filters.component.html',
    providers: [UsersFiltersStore],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        NgClass,
        SearchInputComponent,
        SelectInputComponent,
        SwitchInputComponent,
    ],
})
export class UsersFiltersComponent extends SubscriptionComponent {

    protected readonly store2 = inject(UsersFiltersStore);
    private readonly store = inject(Store);


    @Input({ required: true }) form!: FormGroup;

    serviceOptions: any[] = [];

    constructor() {
        super();
        this.subs.push(
            this.store.select(selectServices).subscribe((services) => {
                this.serviceOptions = services.filter(service => this.store2.allowedServiceIds().includes(service.id));
            }),
        );

        const selectServiceEff = effect(() => {
            const serviceId = this.store2.allowedServiceIds().includes(this.store2.globalGlobalStore.loggedUserStore.selectedServiceId() ?? 0)
                ? this.store2.globalGlobalStore.loggedUserStore.selectedServiceId()
                : this.store2.allowedServiceIds()[0];

            if (serviceId) {
                this.form.patchValue({
                    selectedService: serviceId,
                });
                selectServiceEff.destroy();
            }
        });
    }

    get selectedService(): string {
        return this.form?.get('selectedService')?.value ?? '';
    }

    get showDeactivatedUsers(): boolean {
        return this.form?.get('showDeactivated')?.value ?? false;
    }

    protected readonly OrganizationSettingTypeEnum = OrganizationSettingTypeEnum;

}
